import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/exoty-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-68a590e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Exoty Logo",
  class: "brand-image img-circle elevation-3",
  style: {"opacity":"0.8"}
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "brand-text font-weight-light" }, "Exoty Admin", -1))
const _hoisted_3 = { class: "sidebar" }
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = {
  class: "nav nav-pills nav-sidebar flex-column",
  "data-widget": "treeview",
  role: "menu",
  "data-accordion": "false"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_menu_item = _resolveComponent("app-menu-item")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["main-sidebar elevation-4", _ctx.sidebarSkin])
  }, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "brand-link"
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("nav", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuTree, (item) => {
            return (_openBlock(), _createBlock(_component_app_menu_item, {
              key: item.key,
              menuItem: item
            }, null, 8, ["menuItem"]))
          }), 128))
        ])
      ])
    ])
  ], 2))
}